// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`41.1|151.19000|110.9|159.22500|000.0|H|N|
41.2|151.35500|103.5|159.30000|000.0|H|N|
41.3|151.26500|103.5|159.33000|000.0|H|N|
41.4|151.40000|103.5|159.37500|000.0|H|N|
41.5|151.17500|192.8|151.17500|192.8|L|N|
41.6|151.25000|192.8|151.25000|192.8|L|N|
41.7|151.37000|192.8|151.37000|192.8|L|N|
41.8|151.22000|192.8|151.22000|192.8|L|N|
41.9|159.26250|192.8|159.26250|192.8|L|N|
41.10|159.36750|192.8|159.36750|192.8|L|N|
41.11|154.01000|131.8|155.89500|000.0|H|N|
41.12|153.90500|131.8|158.92500|000.0|H|N|
41.13|154.10000|131.8|158.76000|000.0|H|N|
41.14|153.83000|131.8|153.83000|131.8|H|N|
41.15|155.91000|131.8|155.91000|131.8|H|N|
41.16|153.90500|131.8|158.92500|131.8|H|N|
41.17|171.70000|000.0|165.60000|000.0|H|N|
41.18|171.67500|000.0|165.60000|000.0|H|N|
41.19|170.55000|000.0|166.00000|000.0|H|N|
41.20|170.55000|000.0|170.55000|000.0|H|N|
41.21|169.90000|000.0|165.70000|000.0|H|N|
41.22|169.90000|000.0|169.90000|000.0|H|N|
41.23|168.20000|000.0|168.20000|000.0|L|N|
41.24|167.47500|000.0|167.47500|000.0|L|N|
41.25|168.63750|000.0|168.63750|000.0|L|N|
41.26|171.70000|167.9|165.60000|167.9|H|N|
41.27|171.67500|167.9|165.60000|167.9|H|N|
41.28|168.57500|123.0|168.57000|123.0|L|N|
41.29|168.53750|123.0|168.53750|123.0|L|N|
41.30|171.16250|123.0|164.95000|123.0|L|N|
41.31|173.67500|000.0|173.67500|000.0|L|N|
41.32|154.28000|156.7|154.28000|156.7|H|N|
41.33|154.26500|156.7|154.26500|156.7|L|N|
41.34|154.29500|156.7|154.29500|156.7|L|N|
41.35|154.27250|156.7|154.27250|156.7|L|N|
41.36|154.28750|156.7|154.28750|156.7|L|N|
41.37|154.30250|156.7|154.30250|156.7|L|N|
41.38|151.13750|156.7|151.13750|156.7|L|N|
41.39|154.45250|156.7|154.45250|156.7|L|N|
41.40|158.73750|156.7|158.73750|156.7|L|N|
41.41|159.47250|156.7|159.47250|156.7|L|N|
41.42|154.08500|146.2|156.01500|146.2|H|N|
41.43|156.00000|123.0|155.08500|123.0|H|N|
41.44|159.06750|123.0|155.10000|123.0|H|N|
41.45|155.86500|123.0|155.86500|123.0|L|N|
41.46|154.19000|123.0|154.19000|123.0|L|N|
41.47|154.32500|131.8|153.77000|131.8|H|N|
41.48|154.13000|131.8|154.13000|131.8|H|N|
41.49|154.25750|162.2|158.84250|162.2|H|N|
41.50|156.18000|162.2|156.18000|162.2|L|N|
41.51|156.07500|156.7|156.07500|156.7|H|N|
41.52|151.30250|000.0|000.00000|000.0|H|N|
41.53|153.75500|000.0|154.98000|000.0|H|N|
41.54|168.62500|000.0|168.62500|110.9|L|N|Emergency
42.1|151.35500|103.5|159.30000|000.0|H|N|CDF Command 1
42.2|151.26500|103.5|159.33000|000.0|H|N|CDF Command 2
42.3|151.40000|103.5|159.37500|000.0|H|N|CDF Command 4
42.4|151.46000|123.0|159.39000|000.0|H|N|MMU Local 1
42.5|151.15250|123.0|159.33750|000.0|H|N|MMU Local 2
42.6|154.40000|123.0|159.04500|000.0|H|N|Merced County Fire Net
42.7|153.18500|123.0|158.43000|131.8|H|N|Madera Command Net
42.8|154.07000|123.0|159.01500|131.8|H|N|Madera City Fire Command
42.9|154.35500|123.0|154.35500|123.0|L|N|Madera County TAC Net
42.10|154.38500|123.0|154.38500|123.0|L|N|Madera City TAC Net
42.11|151.32500|192.8|151.32500|192.8|L|N|CDF TAC 6
42.12|151.34000|192.8|151.34000|192.8|L|N|CDF TAC 7
42.13|151.37000|192.8|151.37000|192.8|L|N|CDF TAC 8
42.14|151.22000|192.8|151.22000|192.8|L|N|CDF AIR/GROUND 1
42.15|159.26250|192.8|159.26250|192.8|L|N|CDF AIR/GROUND 2
42.16|159.36750|192.8|159.36750|192.8|L|N|CDF AIR/GROUND 3
42.17|156.07500|156.7|156.07500|156.7|H|N|CALCORD
42.18|154.26500|156.7|154.26500|156.7|L|N|
42.19|151.10000|131.8|159.18000|000.0|H|N|Mariposa County Fire Admin Net
42.20|155.19000|206.5|153.83000|206.5|H|N|XMP Mariposa Co. Command South
42.21|158.76000|206.5|156.04500|206.5|H|N|XMP Mariposa Co. Command North
42.22|170.50000|000.0|168.75000|000.0|H|N|FS-Stanislaus
42.23|172.22500|000.0|164.78750|000.0|H|N|FS-Sierra Fire
42.24|171.47500|000.0|163.68750|000.0|H|N|FS-Sierra Admin
42.25|167.47500|000.0|167.47500|000.0|L|N|FED A/G CA03 Primary
42.26|168.63750|000.0|168.63750|000.0|L|N|FED A/G CA03 Secondary
42.27|172.77500|000.0|166.36250|000.0|H|N|NPS-Yosemite
42.28|166.30000|000.0|164.42500|000.0|H|N|NPS-Yosemite Valley
42.29|172.65000|000.0|171.65000|000.0|H|N|NPS-Yosemite Park
42.30|168.35000|000.0|168.35000|000.0|L|N|NPS-Yosemite Common
42.31|168.56250|000.0|168.56250|000.0|L|N|YOSEMITE AIR TO GROUND
42.32|163.71250|000.0|163.71250|000.0|L|N|YOSEMITE TAC 1
42.33|168.61250|000.0|168.61250|000.0|L|N|YOSEMITE TAC 2
42.34|154.34000|123.0|154.34000|123.0|H|N|MERCED ORANGE TAC
42.35|154.20500|114.8|154.20500|114.8|H|N|ATWATER CITY YELLOW TAC
42.36|154.01000|114.8|156.10500|114.8|H|N|ATWATER CITY COMMAND NET
42.37|154.34000|136.5|154.34000|136.5|H|N|CASTLE AIR BASE TOWER
42.38|155.80500|173.8|158.93250|173.8|H|N|MERCED CITY FIRE COMMAND 1
42.39|153.90500|173.8|158.96250|173.8|H|N|MERCED CITY FIRE COMMAND 2
42.40|154.13000|173.8|154.13000|173.8|L|N|MERCED CITY FIRE TAC 3
42.41|154.17500|173.8|154.17500|173.8|L|N|MERCED CITY FIRE TAC 4
42.42|153.90500|173.8|153.90500|173.8|L|N|MERCED CITY FIRE TAC 5
42.43|154.31000|114.8|150.77500|114.8|H|N|LOS BANOS CITY FIRE
42.44|155.90250|162.2|155.90250|162.2|L|N|LOS BANOS CITY FIRE TAC 1
42.45|155.13750|173.8|155.13750|173.8|L|N|LOS BANOS CITY FIRE TAC 2
42.46|154.10000|136.5|154.10000|136.5|L|N|LOS BANOS CITY FIRE TAC 3
42.47|155.55000|123.0|159.18000|123.0|H|N|LOS BANOS CITY FIRE COMMAND
42.48|155.64000|192.8|154.11500|192.8|H|N|XMD Merced County Command West
42.49|154.89000|192.8|159.15750|192.8|H|N|XMD Merced County Command East
42.50|154.44500|131.8|159.19500|000.0|H|N|
42.51|153.89000|131.8|159.06000|000.0|H|N|
42.52|158.74500|131.8|158.74500|131.8|H|N|
42.53|153.77000|123.0|153.77000|123.0|H|N|
42.54|154.43000|NAC 122|154.05500|NAC 122|H|N|CMD 2, P25 ID 37184, C4FM
42.55|154.43000|123.0|154.05500|123.0|H|N|XST CMD 2 (ANALOG)
42.56|151.01000|82.5|153.87500|82.5|H|N|Stanislaus Co CMD 3
42.57|155.08500|NAC 124|156.09000|NAC 124|H|N|CMD4, P25 ID 37184, C4FM
42.58|155.08500|D464|156.09000|D464|H|N|XST COMMAND 4 (ANALOG)
42.59|155.94000|NAC 125|154.14500|NAC 125|H|N|P25 ID 37184, CQPSK
42.60|155.94000|123.0|154.14500|123.0|H|N|XST COMMAND 5 (ANALOG)
42.61|154.37000|NAC 127|154.37000|NAC 127|L|N|Tac 7, P25 ID 37184, C4FM
42.62|154.37000|123.0|154.37000|123.0|L|N|XST TAC 7 (ANALOG)
42.63|153.90500|NAC 128|153.90500|NAC 128|L|N|Tac 8, P25 ID 37184, C4FM
42.64|153.90500|123.0|153.90500|123.0|L|N|XST TAC 8 (ANALOG)
42.65|154.32500|NAC 129|154.32500|NAC 129|L|N|Tac 9, P25 ID 37184, C4FM
42.66|154.32500|123.0|154.32500|123.0|L|N|XST TAC 9 (ANALOG)
42.67|153.89000|NAC 130|153.89000|NAC 130|L|N|Tac 10, P25 ID 37184, C4FM
42.68|153.89000|123.0|153.89000|123.0|L|N|XST TAC 10 (ANALOG)
42.69|154.41500|NAC 131|154.41500|NAC 131|L|N|Tac 11, P25 ID 37184, C4FM
42.70|154.41500|D131|154.41500|D131|L|N|XST TAC 11 (ANALOG)
42.71|154.19000|NAC 132|154.19000|NAC 132|L|N|Tac 12, P25 ID 37184, C4FM
42.72|154.19000|123.0|154.19000|123.0|L|N|XST TAC 12 (ANALOG)
42.73|151.11500|D723|159.01500|D723|L|N|Stanislaus County TAC 16 (Interop)
42.74|151.31000|||||N|AIR TACTICS 6
42.75|150.99500|156.7|000.00000|000.0||N|RX ONLY for non-LE load
42.76|150.99500|000.0|000.00000|000.0||N|MADERA SO 2, RX Only
42.77|151.07000|156.7|000.00000|000.0||N|MADERA SO 3, RX Only
42.78|153.33500|156.7|000.00000|000.0||N|MADERA SO 4, RX Only
42.79|153.99500|131.8|000.00000|000.0||N|Mariposa County S.O., RX Only
42.80|155.95500|000.0|000.00000|000.0||N|MERCED PD 1, RX Only
42.81|155.52000|114.8|000.00000|000.0||N|MERCED PD 2, RX Only
42.82|152.07500|000.0|000.00000|000.0||N|DOS PALOS PD 1, RX Only
42.83|152.07500|000.0|000.00000|000.0||N|DOS PALOS PD DIRECT, RX Only
42.84|155.84250|000.0|000.00000|000.0||N|DOS PALOS PD 2, RX Only
42.85|155.68500|000.0|000.00000|000.0||N|LIVINGSTON PD, RX Only
42.86|154.2650|156.7|154.26500|156.7|L|N|
42.87|153.75500|000.0|154.98000|000.0|H|N|Travel Net
42.88|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
